export default __webpack_public_path__ + "static/52195-3fbb0e427afb33256a50aae7cd17e675.jpg";